import { Col, Modal, Row } from 'antd';
import styled from 'styled-components';

import DotsIcon from '@asset/dots.icon.svg?react';
import { Button } from '@atom/button/button';

export const Dots = styled(DotsIcon)`
  cursor: pointer;
`;

export const ModalConnections = styled(Modal)`
  width: 520px;
`;

export const ModalConnectionsWrapper = styled(Row)`
  display: flex;
  flex-wrap: wrap;
  padding-top: 24px;
  gap: 24px;
  width: 100%;
`;

export const ModalConnectionsCol = styled(Col)`
  width: calc(50% - 24px / 2);
`;

export const ConnectionButton = styled(Button)`
  padding-left: 0;
  padding-right: 0;
`;
